import { useState } from 'react';
import useTranslate from '../../Hooks/useTranslate';
import Button from '../../Style-guide/Button';
import Input from '../../Style-guide/Input';
import Modal from '../../Style-guide/Modal';
import Title from '../../Style-guide/Title';

const VerificationModal = ({ showModal, setShowModal, userData, request }) => {
  const tr = useTranslate();
  const [code, setCode] = useState('');

  const onChange = (e) => setCode(e.target.value);
  const onSubmit = () => {
    if (code && code.length > 0) {
      request({ data: { ...userData, verificationCode: code } });
    }
  };

  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      onSubmit();
    }
  };

  return (
    <Modal
      show={showModal}
      onClose={() => setShowModal(false)}
      className='verification-modal'
    >
      <Title size='SM' className='verification-title'>
        {tr('enter_the_verification_code')}
      </Title>
      <Input
        type='text'
        name='verificationCode'
        value={code}
        onChange={onChange}
        onKeyDown={handleKeyDown}
        autoComplete='off'
        autoFocus
      />
      <Button className='submit-btn' onClick={onSubmit}>
        {tr('submit')}
      </Button>
    </Modal>
  );
};

export default VerificationModal;
